import userService from '../services/user';
import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ROLE } from '../constants/roles.constant';

// Pick a sensible landing page based on the role the BE returned, so a
// pure teacher account doesn't bounce into `/admin/session` (which
// AdminGuard would reject and Cloudflare LB would treat as a tight
// redirect loop).
const pickLandingPath = (roleArr) => {
  const role = Array.isArray(roleArr) ? roleArr : [];
  if (
    role.includes(ROLE.ADMIN) ||
    role.includes(ROLE.DRIVING.ADMIN) ||
    role.includes(ROLE.DRIVING.DAT_ADMIN)
  ) {
    return '/admin/session';
  }
  return '/';
};

function AdminLoginPage() {
  const { state } = useLocation();
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    userService.login({ userName, password })
      .then((res) => {
        toast.success('Xác thực thành công');
        localStorage.setItem('user-jwt-tk', res?.data?.token);
        localStorage.setItem('user-jwt-rftk', res?.data?.refreshToken);
        localStorage.setItem(
          'user-info',
          JSON.stringify({
            zalo: res?.data?.zalo,
            role: res?.data?.role,
            store: res?.data?.store,
            source: res?.data?.source,
            center: res?.data?.center,
          })
        );
        window.location.href = state?.from || pickLandingPath(res?.data?.role);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Row className="w-100 justify-content-center">
        <Col md={7} lg={5}>
          <Card className="shadow p-4">
            <Card.Body>
              <h3 className="text-center mb-4">Đăng nhập hệ thống</h3>
              <Form onSubmit={handleLogin}>
                <Form.Group controlId="formuserName" className="mb-3">
                  <Form.Label>Tên đăng nhập</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Tên đăng nhập"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formPassword" className="mb-4">
                  <Form.Label>Mật khẩu</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100">
                  Đăng nhập
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default AdminLoginPage;
